import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'anthropic',
  name: 'Anthropic Claude',
  category: 'ai',
  description: 'Anthropic Claude AI model for chat conversations and text generation',
  icon: 'siAnthropic',
  iconType: 'simple-icon',
  color: 'purple',
  version: '1.0.0',
  
  // Mark as sub-node - only used with AI Agent
  isSubNode: true,
  subNodeConfig: {
    category: 'chatModel',
    requiredFor: ['aiAgent'],
    multipleAllowed: false // Only one chat model per AI Agent
  },
  
  group: ['ai'],
  
  defaults: {
    name: 'Anthropic Claude',
    color: '#8b5cf6'
  },
  
  subtitle: '={{ $parameter.model }}',
  
  credentials: [
    {
      name: 'claude',
      required: true,
      displayName: 'Claude API',
      testedBy: 'testAnthropicCredentials'
    }
  ],
  
  requestDefaults: {
    baseURL: 'https://api.anthropic.com/v1',
    headers: {
      'Content-Type': 'application/json',
      'anthropic-version': '2023-06-01'
    }
  },
  
  // Sub-nodes don't have traditional inputs/outputs
  // They are connected via special anchors
  inputs: [],
  outputs: [],
  
  // Anchors define the visual connection points
  anchors: {
    input: [
      {
        type: 'subNode',
        subNodeCategory: 'chatModel',
        label: 'Chat Model',
        multiple: false
      }
    ]
  },
  
  tags: ['ai', 'claude', 'llm', 'chat', 'anthropic', 'text-generation']
};

export default definition;
